import {ActionType} from "../action_type";
// Action Creator
export const showNavigation = (isShow : boolean) => {
  // Return an action
  return {
    type: ActionType.SHOW_NAVIGATION,
    payload: isShow,
  };
};